/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { Roles } from "App/IOC/Services";

import Columns from "./Columns";
import Privileges from "./Privileges";

export default {
    Columns,
    Privileges,
    Find: Roles.Find,
    Get: Roles.Get,
    Create: Roles.Create,
    Update: Roles.Update,
    Delete: Roles.Delete
};
